import { render, staticRenderFns } from "./about-us.html?vue&type=template&id=071f5b88&scoped=true&"
import script from "./about-us.js?vue&type=script&lang=js&"
export * from "./about-us.js?vue&type=script&lang=js&"
import style0 from "./about-us.css?vue&type=style&index=0&id=071f5b88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071f5b88",
  null
  
)

export default component.exports